import { Spinner } from "../Spinner";

/**
 * Full-page / in-content loading indicator used by pages and tabs.
 * Thin wrapper around the shared Spinner atom so every loading state
 * renders the same animated spinner (instead of bare "Loading..." text).
 */
export default function PageLoader1({ label }: { label?: string }) {
  return <Spinner label={label} />;
}
